/** Society setting type identifiers used to look up values in `society.settings`. */
export const SOCIETY_SETTING_TYPE = {
  EBV_FIELDS: 'EBV_FIELDS',
  EBV_AVERAGE: 'EBV_AVERAGE',
  EBV_PERCENTAGES: 'EBV_PERCENTAGES',
  EBV_PERCENTAGES_BR: 'EBV_PERCENTAGES_BR',
  EBV_DESCRIPTION: 'EBV_DESCRIPTION',
  EBV_DESCRIPTION_URL: 'EBV_DESCRIPTION_URL',
  EBV_DISPLAY_OPTIONS: 'EBV_DISPLAY_OPTIONS',
  ANIMAL_LIST_FIELDS: 'ANIMAL_LIST_FIELDS',
  ANIMAL_DETAIL_FIELDS: 'ANIMAL_DETAIL_FIELDS',
  ANIMAL_SEARCH_FIELDS: 'ANIMAL_SEARCH_FIELDS',
  ANIMAL_SEARCH_FIELDS_EXCLUDE: 'ANIMAL_SEARCH_FIELDS_EXCLUDE',
  MEMBER_LIST_FIELDS: 'MEMBER_LIST_FIELDS',
  MEMBER_SEARCH_FIELDS: 'MEMBER_SEARCH_FIELDS',
  MEMBER_DETAIL_FIELDS: 'MEMBER_DETAIL_FIELDS',
  ONLINE_REGISTRATIONS_TAB: 'ONLINE_REGISTRATIONS_TAB',
  SOCIETY_LOGO: 'SOCIETY_LOGO',
} as const;
